// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FrequentQuestions_category-arrow-container__T9iG6 {
  font-weight: bold;
  font-size: 24px;
  display: flex;
}

.FrequentQuestions_question-content-container__YdvKq {
  margin-top: 25px;
}
.FrequentQuestions_question-content-container__YdvKq .FrequentQuestions_question__5dUdz {
  font-size: 16px;
}
.FrequentQuestions_question-content-container__YdvKq .FrequentQuestions_content__fWcIv {
  margin-top: 14px;
  font-size: 12px;
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/views/FrequentQuestions/FrequentQuestions.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,iBCGK;EDFL,eAAA;EACA,aAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;AAIE;EACE,eCXK;ADST;AAKE;EACE,gBAAA;EACA,eClBK;EDmBL,qBAAA;AAHJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.category-arrow-container {\n  font-weight: typography.$bold;\n  font-size: typography.$header-m;\n  display: flex;\n}\n\n.question-content-container {\n  margin-top: 25px;\n\n  .question {\n    font-size: typography.$body-l;\n  }\n\n  .content {\n    margin-top: 14px;\n    font-size: typography.$body-s;\n    white-space: pre-wrap;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category-arrow-container": `FrequentQuestions_category-arrow-container__T9iG6`,
	"question-content-container": `FrequentQuestions_question-content-container__YdvKq`,
	"question": `FrequentQuestions_question__5dUdz`,
	"content": `FrequentQuestions_content__fWcIv`
};
export default ___CSS_LOADER_EXPORT___;
